<app-notes [moduleId]="moduleId" [entityId]="entityId" urlPrefix="/client/contact-show"></app-notes>